import gql from 'graphql-tag';

export default gql`
  fragment salesforceAccountFieldFragment on SalesforceAccountField {
    id
    fieldName
    fieldType
    label
    isDisplay
    updateable
  }
`;
